import { Injectable } from '@angular/core';

@Injectable()
export class Utils {
  serializeJSON (val: any, prefix): any {
    let url = '';

    if (prefix) {
      url = prefix;
    }

    if (this.isJson(val)) {
      url += Object.keys(val).map((k) => {
        return encodeURIComponent(k) + '=' + encodeURIComponent(val[k])
      }).join('&');
    }

    return url;
  }

  isJson(item: any): boolean {
    item = typeof item !== "string"
        ? JSON.stringify(item)
        : item;

    try {
        item = JSON.parse(item);
    } catch (e) {
        return false;
    }

    if (typeof item === "object" && item !== null) {
        return true;
    }

    return false;
  }
}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/services/utils.service.ts